import { User } from '@auth0/auth0-spa-js';

export interface ILayoutDocumentData {
  title: string;
  selectedEnclosures: number[];
}

export interface IBOMFileModel {
  user: User,
  fileName: string,
  loaderProperty?: DocumentLoaderKeys
}

export interface IDispositionLayoutModel {
  title: string,
  showCovers: boolean,
  loaderProperty?: DocumentLoaderKeys
}

export interface IRoutineVerificationLayoutData {
  title: string;
  selectedEnclosure: number;
}

export interface IDocumentLoaderStates {
  bomWithPrice: boolean;
  bomWithPriceXL: boolean;
  bomWithOutPrice: boolean;
  bomWithOutPriceXL: boolean;
  enclosureLayout: boolean;
  enclosureLayoutWithCover: boolean;
  dispositionLayout: boolean;
  dispositionLayoutWithCover: boolean;
  labels: boolean;
  labelsBackSide: boolean;
  ratingPlate: boolean;
  ratingPlateXL: boolean;
  sld: boolean;
  zip: boolean;
}

export interface IDocument {
  blob: Blob;
  name: string;
}

export enum DocumentLoaderKeys {
  BOM_WITH_PRICE = 'bomWithPrice',
  BOM_WITH_PRICE_XL = 'bomWithPriceXL',
  BOM_WITHOUT_PRICE = 'bomWithOutPrice',
  BOM_WITHOUT_PRICE_XL = 'bomWithOutPriceXL',
  ENCLOSURE_LAYOUT = 'enclosureLayout',
  ENCLOSURE_LAYOUT_WITH_COVER = 'enclosureLayoutWithCover',
  DISPOSITION_LAYOUT = 'dispositionLayout',
  DISPOSITION_LAYOUT_WITH_COVER = 'dispositionLayoutWithCover',
  LABELS = 'labels',
  LABELS_BACKSIDE = 'labelsBackSide',
  RATING_PLATE = 'ratingPlate',
  RATING_PLATE_XL = 'ratingPlateXL',
  SLD = 'sld',
  ZIP = 'zip',
}
